// import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';
// project-imports
// import CommonLayout from 'layout/CommonLayout';
// import Loadable from 'components/Loadable';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import Loadable from 'components/Loadable';
import { lazy } from 'react';
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/error/404')));
// render - landing page
// const PagesLanding = Loadable(lazy(() => import('pages/landing')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([LoginRoutes, MainRoutes, { path: '*', element: <MaintenanceError /> }]);
}
